export enum BlockState {
    Clear = 0,
    Filled,
    Goal,
    Start,
  }